import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {PUT_DISABLE_REQUEST_TYPES_URL} from '../../constants/apiUrls';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: void) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePutDisableRequestTypes = ({onSuccess, onError}: Input = {}) => {
  const putDisableRequestTypes = async (uuid: string) => {
    await axiosClient.put(PUT_DISABLE_REQUEST_TYPES_URL(uuid));
  };

  return useCustomMutation(putDisableRequestTypes, {
    onSuccess,
    onError,
  });
};
